// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Oba-z","fadeIn":"Pba-z","delay":"Qba-z","recommendedSizeTooltip":"Rba-z"};